import React, { Component, PureComponent, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import * as ResultsLive from '~/web-frontend-components/results/ResultsLive'
import { withRouter } from 'react-router-dom';
import LoadingSpinner from '../loadingSpinner/';
import Message from '../message';

@withRouter
@inject('resultStore', 'dictStore')
@observer
export default class Result extends Component {
  componentDidMount() {
    const liveResults = this.props.resultStore.liveResults;
    liveResults.tables.subscribe(this.onupdate);
    liveResults.menu.subscribe(this.onupdate);
  }

  componentWillUnmount() {
    const liveResults = this.props.resultStore.liveResults;
    liveResults.tables.unsubscribe(this.onupdate);
    liveResults.menu.unsubscribe(this.onupdate);
  }

  onupdate = () => {
    this.setState({ upd: Date.now() });
  };

  getXHRdata() {
    const sport = Object.values(toJS(this.props.resultStore.results.sport || {}));
    return sport.map(({ id, league, sport_name }) => {
      return {
        id,
        championships: league.map((championshipID) => {
          const { league_name, games } = this.props.resultStore.results.league.get(championshipID);
          return {
            id: championshipID,
            /** Название спорта вместе с чемпионатом */
            text: `${sport_name}.${league_name}`,
            matches: games.map((matchID) => {
              const { name, score, date } = this.props.resultStore.results.games.get(matchID);
              const [team1, team2] = name.split(' - ');
              return { id: matchID, time: date, score, team1, team2 };
            })
          };
        }),
      };
    });
  }
  handleCloseError = () => {
    this.props.resultStore.clearError();
  }
  render() {
    const liveResults = this.props.resultStore.liveResults;
    const wssData = liveResults.tables.getData();
    const isAnySportSelected = liveResults.menu.getSelected().length !== 0;
    const { mode, result } = this.props.resultStore;
    const { getLang } = this.props.dictStore;
    const isLiveMode = mode === 'live';
    const results = this.props.resultStore.results;
    const { isLoading, noResultSport } = results;
    if (isLoading) {
      return <LoadingSpinner />;
    }
    if (!isAnySportSelected) {
      return <Message type={'result-error'} text={"SELECT_SPORT"} onClose={this.handleCloseError} />;
    }
    if (!isLiveMode && result.status) {
      return <Message type={result.type} text={result.text} onClose={this.handleCloseError} />;
    }

    const xhrData = this.getXHRdata();
    if (
      isAnySportSelected && !wssData && xhrData.length === 0 ||
      noResultSport && noResultSport.length !== 0
    ) {
      return <Message type={1} text={'NO_RESULTS'} onClose={this.handleCloseError} />;;
    }
    // const onClick = (sportID, championshipID, matchID) => {
    //   this.props.history.push(`/${mode}/${sportID}/${championshipID}/${matchID}`);
    // };
    const { mainScore } = this.props.resultStore.menu;
    const getInfo = (matchID) => {
      if (!results.games.has(matchID)) { return {}; }
      const { dopBets, refund } = results.games.get(matchID) || {};
      return {
        additionalBets: !mainScore && toJS(dopBets),
        cancel: results.cancel[matchID],
        refund,
      };
    };
    return <ResultsLive.Tables
      toLocale={getLang}
      getInfo={getInfo}
      sports={isLiveMode && wssData || xhrData}
      // onClick={isLiveMode ? onClick : void 0}
    />;
  }
}


// WEBPACK FOOTER //
// ./src/components/results/results.js